import styled from 'styled-components';

import {
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledUpsellContainer = styled.div`
    background-color: ${token('colors.blue200')};
    text-align: center;
    margin: 0 -${spaceMixin('lg')};
    padding: ${spaceMixin('lg')};
`;
